import type { ActivityHubViewProps } from "@/lib/activities/registry";
import { ViewConnectMomentView } from "./view-connect-moment-view";

export function ConnectMomentHubView({
  entity,
  mentorship,
  mentorAvatarUrl,
  teenAvatarUrl,
  currentIndex,
  totalEntities,
  isLoadingNextPage,
  activeTab,
  initialIndex,
  onPrevious,
  onNext,
  onNavigateToList,
}: ActivityHubViewProps) {
  if (!entity) return null;
  return (
    <ViewConnectMomentView
      entity={entity}
      menteeId={mentorship.mentee.id}
      mentorId={mentorship.mentor.id}
      mentorAvatarUrl={mentorAvatarUrl}
      teenAvatarUrl={teenAvatarUrl}
      currentIndex={currentIndex}
      totalEntities={totalEntities}
      isLoadingNextPage={isLoadingNextPage}
      activeTab={activeTab}
      initialIndex={initialIndex}
      onPrevious={onPrevious}
      onNext={onNext}
      onNavigateToList={onNavigateToList}
    />
  );
}
